import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/sms-panel"

export const getBulkSmsTemplates = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/templates?${query}`)

  return response.data
}

export const saveBulkSmsTemplate = async data => {
  const response = await farasod.post(`${endpoint}/templates`, data)

  return response.data
}

export const editBulkSmsTemplate = async (templateId, data) => {
  const response = await farasod.patch(`${endpoint}/templates/${templateId}`, data)

  return response.data
}

export const deleteBulkSmsTemplate = async templateId => {
  const response = await farasod.delete(`${endpoint}/templates/${templateId}`)

  return response.data
}

export const sendBulkSms = async data => {
  const response = await farasod.post(`${endpoint}/bulk-send`, data)

  return response.data
}

export const previewBulkSms = async data => {
  const response = await farasod.post(`${endpoint}/bulk-preview`, data)

  return response.data
}

export const getBulkSmsRequests = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/bulk-requests?${query}`)

  return response.data
}

export const getSmsAutomationRules = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/automation-rules?${query}`)

  return response.data
}

export const saveSmsAutomationRule = async data => {
  const response = await farasod.post(`${endpoint}/automation-rules`, data)

  return response.data
}

export const updateSmsAutomationRule = async (ruleId, data) => {
  const response = await farasod.patch(`${endpoint}/automation-rules/${ruleId}`, data)

  return response.data
}

export const deleteSmsAutomationRule = async ruleId => {
  const response = await farasod.delete(`${endpoint}/automation-rules/${ruleId}`)

  return response.data
}
